import * as React from "react";
import {Component, CSSProperties} from "react";

export class Item extends React.Component<ItemProps, ItemState> {
    static defaultProps: Partial<ItemProps> = {};

    constructor(props: ItemProps) {
        super(props);
        this.state = {};
    }

    public render() {
        return (
             <h2>a</h2>
        )
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface ItemProps {
    Title:string;
    Icon?:JSX.Element;
    Id:any;
    style:CSSProperties;
}

interface ItemState {

}

//#endregion "My Region"